import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-invoice-warning-confirm',
  templateUrl: './invoice-warning-confirm.component.html',
  styleUrls: ['./invoice-warning-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceWarningConfirmComponent {
  @Input() titleKey!: string;
  @Input() descriptionKey!: string;

  @Input() titleParams?: Record<string, any>;
  @Input() descriptionParams?: Record<string, any>;

  @Output() backClicked = new EventEmitter<void>();
  @Output() confirmClicked = new EventEmitter<void>();

  back(): void {
    this.backClicked.emit();
  }

  confirm(): void {
    this.confirmClicked.emit();
  }
}
